import { FILTER_TYPES } from 'components/FilterPod';

const filters = [
  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: 'fromDate',
      end: 'toDate',
    },
    query: {
      start: 'fromDate',
      end: 'toDate',
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  
];

export default filters;
